import { render, staticRenderFns } from "./today.vue?vue&type=template&id=2d723378&"
import script from "./today.vue?vue&type=script&lang=js&"
export * from "./today.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports